import { Bucket } from './bucket';

export enum LocalStorageKey {
  lastProjectId = 'last_project_id',
  bannerWasClosed = 'banner_was_closed',
  wzMigrationBannerWasClosed = 'wz_migration_banner_was_closed',
  connectorType = 'connector_type',
  scenarioPos = 'scenario_pos',
  authAB = 'auth_a_b',
  paymentStateBeforePayment = 'payment_state_before_payment',
  withoutPaymentsStateBeforePayment = 'without_payments_state_before_payment',
  wsAuthToken = 'ws_auth_token',
  shopbackToken = 'shopback_token',
  cabinetInMenuOpened = 'cabinet_in_menu_opened',
  menuOpened = 'menu_opened',
  scenariosActionsOpened = 'scenarios_actions_opened',
  usersPageActionsOpened = 'users_page_actions_opened',
  pinnedVarColumns = 'pinned_var_columns',
  createdInvoiceBannerWasClosed = 'created_invoice_banner_was_closed',
  aiEducationParams = 'ai_education_params',
  firstConnectionStateBeforePayment = 'first_connection_state_before_payment',
  onboardingStepChannelCreateCompleted = 'onboarding_step_channel_create_completed',
  onboardingStepScenarioCreateCompleted = 'onboarding_step_scenario_create_completed',
  onboardingStepBotCapabilitiesCompleted = 'onboarding_step_bot_capabilities_completed',
  onboardingStepBotCreationDemoCompleted = 'onboarding_step_bot_creation_demo_completed',
  onboardingQuickStartSent = 'onboarding_quick_start_sent',
  onboardingFinishSent = 'onboarding_finish_sent',
  maxBannerWasClosed = 'max_banner_was_closed',
  authConsents = 'auth_consents'
}

export enum CookieKey {
  lng = 'lng'
}

export const createScenarioPosKey = ({
  id,
  bucket
}: {
  id: string;
  bucket: Bucket;
}): string => `scenario_${bucket}_${id}`;

export const createShopbackTokenKey = (projectId: string): string =>
  `${LocalStorageKey.shopbackToken}_${projectId}`;

export const createWsAuthTokenKey = (
  projectId: string,
  userId: string
): string => `${LocalStorageKey.wsAuthToken}_${projectId}_${userId}`;

export const createScenariosActionsOpenedKey = (projectId: string): string =>
  `${LocalStorageKey.scenariosActionsOpened}_${projectId}`;

export const createUsersPageActionsOpenedKey = (projectId: string): string =>
  `${LocalStorageKey.usersPageActionsOpened}_${projectId}`;

export const createPinnedVarColumnsKey = (projectId: string): string =>
  `${LocalStorageKey.pinnedVarColumns}_${projectId}`;

export const createAiEducationParamsKey = (
  projectId: string,
  ai_bot_id: string
): string => `${LocalStorageKey.aiEducationParams}_${projectId}_${ai_bot_id}`;

export const createFirstConnectionKey = (
  projectId: string,
  ai_bot_id: string | null
): string =>
  `${LocalStorageKey.firstConnectionStateBeforePayment}_${projectId}_${
    ai_bot_id ?? 'new'
  }`;
